import { authentication } from '@microsoft/teams-js';
import { useEffect } from 'react';
import SessionService from '../services/sessionService';
import TimekeeperService from '../services/timekeeperService';

const PlatformIdentityLogoutCallback = () => {
    useEffect(() => {
        const handleLogout = async () => {
            try {
                // Clean up session storage
                sessionStorage.removeItem("X-Auth-Token");
                sessionStorage.removeItem("refreshToken");
                sessionStorage.removeItem("userId");
                sessionStorage.removeItem("piToken");
                sessionStorage.removeItem("PI-X-Auth-Token");
                sessionStorage.removeItem("UserOrgReference");
                sessionStorage.removeItem("IdentityProvider");
                
                SessionService.clearUserSession();
                TimekeeperService.clearCache();
                
                // Notify Teams that logout is complete
                authentication.notifySuccess("logout-complete");
                
                // Navigate main window to login redirect page after popup closes
                // Use window.opener if available (popup context), otherwise use current window
                setTimeout(() => {
                    const targetWindow = window.opener || window;
                    targetWindow.location.hash = "/loginRedirect";
                }, 500);
            } catch (error) {
                console.error('PlatformIdentityLogoutCallback - Error:', error);
                authentication.notifyFailure(error instanceof Error ? error.message : 'Logout callback error');
                // Navigate to login even on error
                setTimeout(() => {
                    const targetWindow = window.opener || window;
                    targetWindow.location.hash = "/loginRedirect";
                }, 500);
            }
        };

        handleLogout();
    }, []);

    return (
        <div>
            <h1>Logging out...</h1>
        </div>
    );
};

export default PlatformIdentityLogoutCallback;

